// extracted by mini-css-extract-plugin
export default {"GateBody":"WidgetBodySelector_GateBody__Tj23h"};